"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PharmacyConfirmation = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Pharmacy_service_1 = __importDefault(require("../../../../services/Pharmacy.service"));
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const atome_1 = require("../../../atome");
const organisms_1 = require("../../../organisms");
const PharmacyConfirmation_styles_1 = require("./PharmacyConfirmation.styles");
const UtilityFunctions_1 = require("../../../../helper/UtilityFunctions");
const pharmacyReducer_1 = require("../../../../store/reducers/pharmacyReducer");
const InputLoader_1 = __importDefault(require("../../../atome/InputLoader/InputLoader"));
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
function PharmacyConfirmation({ navigation, route, setCurrentPage }) {
    const chosenPharmacy = route.params.chosenPharmacy;
    const creationMode = chosenPharmacy.id === undefined;
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const prescriptionInfo = (0, hooks_1.useAppSelector)(reducers_1.selectPrescriptionInfo);
    const pharmaciesList = (0, hooks_1.useAppSelector)(pharmacyReducer_1.selectPharmacies);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const patientComesFromFUPRequest = () => {
        return ((0, UtilityFunctions_1.isInObject)(prescriptionInfo, 'isSamePharmacy') &&
            prescriptionInfo.isSamePharmacy === false);
    };
    const returnToFUPRequest = (newPhramacyIdOrName) => {
        let reducerType = {
            type: '[UPDATE]',
            payload: {
                followUpPrescriptionsIndex: 9,
            },
        };
        let newPharmacyName;
        if (typeof newPhramacyIdOrName === 'number') {
            const chosenPharmacy = pharmaciesList.find(item => item.id === newPhramacyIdOrName);
            newPharmacyName = chosenPharmacy?.name;
        }
        if (typeof newPhramacyIdOrName === 'string') {
            newPharmacyName = newPhramacyIdOrName;
        }
        dispatch((0, reducers_1.setPrescriptionInfo)({
            ...prescriptionInfo,
            newPharmacy: newPharmacyName,
        }));
        setCurrentPage(reducerType);
        navigation.navigate('FollowPrescription');
    };
    const chosePharmacy = async () => {
        setSaving(true);
        const data = {
            pharmacyId: chosenPharmacy.id,
            patientId: parseInt(userInformation.id),
        };
        const response = await Pharmacy_service_1.default.savePatientPharmacyRelation(data);
        if (!response.error) {
            const newUserInformation = { ...userInformation };
            newUserInformation.patientPharmacyRelation = chosenPharmacy;
            dispatch((0, reducers_1.setUserInformation)(newUserInformation));
        }
        setSaving(false);
        patientComesFromFUPRequest()
            ? returnToFUPRequest(data.pharmacyId)
            : navigation.navigate('PharmacyPage');
    };
    const createPharmacy = async () => {
        const data = {
            patientId: parseInt(userInformation.id),
            name: chosenPharmacy.name,
            street: chosenPharmacy.street,
            postcode: chosenPharmacy.postcode,
            city: chosenPharmacy.city,
            phone: chosenPharmacy.phone,
            houseNumber: chosenPharmacy.houseNumber,
        };
        const response = await Pharmacy_service_1.default.createPharmacy(data);
        if (!response.error) {
            chosenPharmacy.id = response.data.data.id;
            await chosePharmacy();
            patientComesFromFUPRequest()
                ? returnToFUPRequest(chosenPharmacy.name)
                : navigation.navigate('PharmacyPage');
        }
    };
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, { style: [PharmacyConfirmation_styles_1.styles.whiteBackground] },
            react_1.default.createElement(react_native_1.ScrollView, { style: [PharmacyConfirmation_styles_1.styles.scrollview] },
                react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: PharmacyConfirmation_styles_1.styles.container },
                    react_1.default.createElement(atome_1.Icon, { icon: "pharmacy", size: 90 }),
                    react_1.default.createElement(react_native_1.Text, { style: PharmacyConfirmation_styles_1.styles.heading3Green }, " Angaben pr\u00FCfen"),
                    react_1.default.createElement(react_native_1.Text, { style: [PharmacyConfirmation_styles_1.styles.modalText] }, "M\u00F6chten Sie diese Apotheke w\u00E4hlen?"),
                    react_1.default.createElement(react_native_1.View, { style: [PharmacyConfirmation_styles_1.styles.pharmacyText] },
                        react_1.default.createElement(react_native_1.Text, { style: [PharmacyConfirmation_styles_1.styles.heading3Black] }, chosenPharmacy.name),
                        react_1.default.createElement(react_native_1.Text, { style: [PharmacyConfirmation_styles_1.styles.heading4] }, (chosenPharmacy.street ? chosenPharmacy.street + ' ' : '') +
                            (chosenPharmacy.houseNumber ?? '')),
                        react_1.default.createElement(react_native_1.Text, { style: PharmacyConfirmation_styles_1.styles.heading4 }, (chosenPharmacy.postcode
                            ? chosenPharmacy.postcode + ' '
                            : '') + (chosenPharmacy.city ?? ''))),
                    react_1.default.createElement(react_native_1.View, { style: PharmacyConfirmation_styles_1.styles.buttonContainer },
                        react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                                isSaving ? PharmacyConfirmation_styles_1.styles.buttonLoading : PharmacyConfirmation_styles_1.styles.button,
                                GlobalStyles_1.globalStyles.saveButtonContainer,
                            ], onPress: creationMode ? createPharmacy : chosePharmacy },
                            isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                            react_1.default.createElement(react_native_1.Text, { style: PharmacyConfirmation_styles_1.styles.buttonText }, "Diese Apotheke w\u00E4hlen")),
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('PharmacyListPage') },
                            react_1.default.createElement(react_native_1.Text, { style: PharmacyConfirmation_styles_1.styles.backButtonText }, "\u2190 Zur\u00FCck"))))))));
}
exports.PharmacyConfirmation = PharmacyConfirmation;
